
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ZBreadcrumbItem',
  inject: ['breadcrumbSeparator'],
  props: {
    isCurrent: {
      default: false,
      type: Boolean
    }
  }
})
